import { combineTokens } from '@utils/css';

combineTokens("--drawer", {
  amountOfColumns: 5,
  amountOfRows: 1
});
const drawer = "_35sd1i2o24k";
const label = "_35sl1q8akql";

export { drawer, label };
import "./molecule.drawer.style.linaria.module.css";
//# sourceMappingURL=molecule.drawer.style.js.map
